import { Button } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../hooks';

export const LogoutButton: FunctionComponent = () => {
  const translate = useAppTranslate();
  const { keycloak } = useKeycloak();
  const logout = (): void => {
    keycloak.logout({
      redirectUri: process.env.REACT_APP_KEYCLOAK_POST_LOGOUT_REDIRECT_URI,
    });
  };
  return <Button onClick={logout}>{translate('logout', { ns: 'profileMenu' })}</Button>;
}
